import React from 'react';
import { Container } from './styles';

const HeaderTable = () => {
  return (
    <Container>
      <span style={{ width: '8%' }} />
      <span style={{ width: '25%' }}>Tarefa</span>
      <span style={{ width: '25%' }}>Status</span>
      <span style={{ width: '42%' }}>Data de Conclusão</span>
    </Container>
  );
};

export default HeaderTable;
